const faqs = [
  {
    q: '白云视频和苹果视频、榴莲视频是什么关系？',
    a: '白云视频、苹果视频和榴莲视频都是同类型的手机视频播放平台，提供免费在线观影服务。白云视频在播放体验和内容覆盖上对标同类产品，同时在界面设计与推荐算法上持续优化，为用户带来更流畅的看片体验。',
  },
  {
    q: '白云视频是否需要注册或付费？',
    a: '白云视频完全免费，用户无需注册或付费即可畅享全部影视内容。我们坚持免费观影理念，通过技术优化降低成本，让每一位用户都能无障碍地享受高清视频播放服务。',
  },
  {
    q: '支持哪些设备观看？画质如何？',
    a: '白云视频完美适配iOS和Android手机、平板等移动设备，同时提供Web网页版支持电脑浏览器观看。画质最高支持1080P超清播放，系统会根据网络状况自动调整最佳清晰度，确保流畅不卡顿。',
  },
  {
    q: '播放卡顿或加载失败怎么办？',
    a: '建议先切换网络环境（Wi-Fi/移动数据），或尝试清除浏览器缓存后重试。白云视频采用智能CDN加速与P2P传输技术，正常情况下可实现秒开秒播。如仍有问题，可通过联系我们页面反馈，技术团队会及时处理。',
  },
  {
    q: '内容多久更新一次？',
    a: '白云视频内容每日实时更新，涵盖最新院线大片、热播剧集、热门综艺、动漫番剧等全品类资源。用户可通过最新动态模块了解近期更新内容，也可以通过分类索引快速找到感兴趣的影片。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100/80 text-primary-700 text-xs font-medium mb-4">
            <i className="ri-question-answer-line"></i>
            <span className="whitespace-nowrap">帮助中心</span>
          </div>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950">常见问答</h2>
          <p className="mt-2 text-sm text-foreground-500">关于白云视频，你想知道的都在这里</p>
        </div>

        <div className="max-w-3xl mx-auto flex flex-col gap-4">
          {faqs.map((faq, idx) => (
            <div
              key={idx}
              className="p-5 rounded-xl bg-background-50 border border-background-200/60"
            >
              <h3 className="text-sm font-semibold text-foreground-900 mb-2 flex items-start gap-2">
                <span className="text-primary-500 font-bold flex-shrink-0">Q{idx + 1}.</span>
                <span>{faq.q}</span>
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed pl-5">{faq.a}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}